import { Component } from '@angular/core';

@Component({
  selector: 'app-contribution',
  imports: [],
  templateUrl: './contribution.html',
  styleUrl: './contribution.scss',
})
export class Contribution {

}
